import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, HelpCircle, Phone } from 'lucide-react';

const FloatingContactButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/contact');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={handleClick}
        className="group relative bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-blue-300"
        aria-label="Contact Support"
      >
        {/* Main Icon */}
        <MessageCircle className="w-6 h-6" />
        
        {/* Pulse Animation */}
        {/* <div className="absolute inset-0 rounded-full bg-blue-600 animate-ping opacity-20"></div>
         */}
        {/* Tooltip */}
        <div className="absolute right-full ml-4 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <div className="bg-gray-800 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap">
            Need Help? Contact Us
            <div className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-r-gray-800"></div>
          </div>
        </div>
      </button>
    </div>
  );
};

export default FloatingContactButton;